import { fork, take, select, put } from 'redux-saga/effects';
import { pathOr } from 'ramda';
import { replace } from '../../store/actions/history';
import { LOCATION_CHANGE } from '../reducers/location';

// Selectors
const getAccessToken = state => pathOr(false, ['login', 'auth', 'access_token'], state);

function * watchLocationChange() {
  // eslint-disable-next-line no-constant-condition, no-loops/no-loops
  while (true) {
    const payload = yield take([LOCATION_CHANGE, 'REFRESH_PAGE']);
    const accessToken = yield select(getAccessToken);
    let pathname = payload.payload.pathname;
    if (pathname && !accessToken && !pathname.match(/^\/login/)) {
      yield put(replace('/login'));
    } else {
      // console.log(pathname);
    }
  }
}

export default [
  // fork(watchLocationChange),
];
